import { render } from "./CreateSupplierModal.vue?vue&type=template&id=62337394&scoped=true"
import script from "./CreateSupplierModal.vue?vue&type=script&lang=js"
export * from "./CreateSupplierModal.vue?vue&type=script&lang=js"

import "./CreateSupplierModal.vue?vue&type=style&index=0&id=62337394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62337394"]])

export default __exports__